import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Row, Col } from 'antd';

import Api from '../../api/Api';

const { Option } = Select;

const AddCostumer = ({ isVisible, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [users, setUsers] = useState([]); // Estado para armazenar os usuários
  const usuario = JSON.parse(localStorage.getItem('user'));



  // Busca os usuários ao carregar o modal
  useEffect(() => {
    const fetchUsers = async () => {
      try {

        const dados = {
          id: usuario.id,
         
        };

        const response = await Api.ListUser(dados);
        console.log('Resposta da API:', response);
        if (response.success) {
          setUsers(response.users); // Atualiza o estado com a lista de usuários
        } else {
          console.error('Erro ao buscar usuários:', response.message);
        }
      } catch (error) {
        console.error('Erro na API:', error);
      }
    };

    if (isVisible) {
      fetchUsers(); // Carrega os usuários apenas quando o modal é visível
    }
  }, [isVisible]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values); // Passa os dados para o componente pai
        form.resetFields();
        onClose(); // Fecha o modal
      })
      .catch((errorInfo) => {
        console.error('Erro de validação:', JSON.stringify(errorInfo, null, 2));
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <div>
      <Modal
        title="Adicionar Cliente"
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Form form={form} layout="vertical">
          {/* Nome */}
          <Form.Item
            label="Nome"
            name="nome"
            rules={[
              { required: true, message: 'Por favor, insira o nome!' },
              { max: 150, message: 'O nome deve ter no máximo 150 caracteres!' },
            ]}
          >
            <Input placeholder="Digite o nome" maxLength={150} />
          </Form.Item>

       
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Nº de Telefone"
                name="telefone"
                rules={[
                  { required: true, message: 'Por favor, insira o nº de telefone!' },
                  { pattern: /^\d{1,9}$/, message: 'Digite apenas números com no máximo 9 dígitos!' },
                ]}
              >
                <Input placeholder="Digite o nº de telefone" maxLength={9} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="NIF"
                name="nif"
                rules={[
                  { required: true, message: 'Por favor, insira o NIF!' },
                  { max: 15, message: 'O NIF deve ter no máximo 15 caracteres!' },
                ]}
              >
                <Input placeholder="Digite o NIF" maxLength={15} />
              </Form.Item>
            </Col>
          </Row>

          {/* Parceiros */}
          <Form.Item
            label="Parceiro"
            name="parceiro"
            rules={[{ required: true, message: 'Por favor, selecione um parceiro!' }]}
          >
            <Select placeholder="Selecione um parceiro">
              {users.map((user) => (
                <Option key={user.id} value={user.id}>
                  {user.Nome}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddCostumer;
